import { cn } from '@/lib/utils'
import { useUIStore } from '@/stores/ui.store'

import { Header } from './header'
import { PageBreadcrumb } from './page-header'
import { Sidebar } from './sidebar'
import { TabBar } from './tab-bar'

import type { ReactNode } from 'react'

interface MainLayoutProps {
  children: ReactNode
}

/**
 * 主布局组件
 * - 包含侧边栏、头部、标签栏、面包屑和主内容区
 * Requirements: 7.1, 7.4, 7.5
 */
export function MainLayout({ children }: MainLayoutProps) {
  const sidebarCollapsed = useUIStore((state) => state.sidebarCollapsed)

  return (
    <div className="flex h-screen overflow-hidden bg-background">
      {/* 侧边栏 */}
      <Sidebar />

      {/* 主内容区 */}
      <div
        className={cn(
          'flex flex-1 flex-col overflow-hidden transition-all duration-300',
          sidebarCollapsed ? 'ml-16' : 'ml-64'
        )}
      >
        {/* 头部 */}
        <Header />

        {/* 标签栏 */}
        <TabBar />

        {/* 面包屑导航 (Requirements: 7.1, 7.4, 7.5) */}
        <div className="border-b bg-background/95 px-6 py-2">
          <PageBreadcrumb />
        </div>

        {/* 内容区 */}
        <main className="flex-1 overflow-auto p-6">{children}</main>
      </div>
    </div>
  )
}
